module.exports = __webpack_public_path__ + "static/media/heart.65e0a449.png";